/**
 * util functions to handle data related to api request and response
 */

export function getErrorMessage(err) {
  if (err?.response?.data?.message) {
    // Use the server's error message
    return err.response.data.message;
  } else if (err?.response?.data?.error) {
    // Use the server's error details
    return err.response.data.error;
  } else if (typeof err?.response?.data === 'string' && err.response.data) {
    // Handle plain string error responses
    return err.response.data;
  } else if (err?.message) {
    // Fallback to the general error message
    return err.message;
  }
  return 'Something went wrong'; //default error message;
}

// The server's reasons for refusing a request, as plain sentences for a
// message: its list of errors joined (a list of sentences, or ASP.NET's
// errors by field), else its own message or text, else the error's. Never the
// raw reply: a list shown as it came read ["... already has a result ..."]
// with brackets and quotes (Doug, 2026-10-23).
export function getErrorDetails(err, fallback = 'Something went wrong') {
  const data = err?.response?.data;
  const errors = data?.errors ?? data?.Errors;
  const sentences = Array.isArray(errors)
    ? errors
    : errors && typeof errors === 'object'
      ? Object.values(errors).flat()
      : [];
  const text = sentences.filter((sentence) => typeof sentence === 'string' && sentence.trim());
  if (text.length > 0) return text.join(' ');
  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message || data?.Message) return data.message || data.Message;
  if (err?.message) return err.message;
  return fallback;
}
